
export enum CollectMoneyAtDeliveryCd {
	BOTH = 'Both',
	COD = 'Cod',
	FREIGHT = 'Freight',
	NONE = 'None'}
